module.exports = __webpack_public_path__ + "static/fonts/NotoSansKR-Medium-Hestia.a440c63.eot";